import BaseStore from "../base/BaseStore";
import { ActionInterface, StoreActionType } from "../constant/ActionConstant";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Service from "../model/service/Service";

class HubRiseStore extends BaseStore {

    private _service: Service

    constructor() {
        super();
        this._service = new Service();
    }

    public get service(): Service {
        return this._service;
    }

    setService(service: Service) {
        this._service = service;
        this.emitChange();
    }

}

const storeActions = (store: HubRiseStore) => {
    return (action: ActionInterface) => {
        switch(action.type) {
            case StoreActionType.SET_HUBRISE_SERVICE:
                store.setService(action.data);
                break;
        }
    }
};

const hubRiseStoreShared = new HubRiseStore();
hubRiseStoreShared.dispatchToken = AppDispatcher.register(storeActions(hubRiseStoreShared) as (payload: unknown) => void);

export default hubRiseStoreShared;
export const store = HubRiseStore;
export const action = storeActions;